var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ActiveSubmenuContextProvider } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { SideFlyoutMenu } from './SideFlyoutMenu';
import { NavThemeProvider } from '../NavThemeProvider';
import { useS4XMastheadContext } from '../../S4XMastheadProvider';
import { useUserState } from '../hooks/useUserState';
import { NavBarHeightSmScreen } from '../constants';
import { SecondaryNavContainer } from '../../SecondaryNav/SecondaryNavContainer';
import SecondaryNav from '../../SecondaryNav';
export var NavBarCompact = function (_a) {
    var forcedUserState = _a.forcedUserState, colors = _a.colors, className = _a.className;
    var userState = useUserState(forcedUserState);
    var _b = useS4XMastheadContext(), mastheadData = _b.mastheadData, secondaryNavigation = _b.secondaryNavigation;
    if (userState === 'loading' || !mastheadData) {
        return React.createElement("div", null);
    }
    return (React.createElement(NavThemeProvider, { colors: colors },
        React.createElement(ActiveSubmenuContextProvider, null,
            React.createElement("div", { className: className },
                React.createElement(SideFlyoutMenu, { forcedUserState: forcedUserState })),
            secondaryNavigation && (React.createElement(SecondaryNavContainer, { primaryNavHeight: NavBarHeightSmScreen, transitionIn: { duration: 0.4 }, transitionOut: { duration: 0.2 }, showVisibleDelay: 100 },
                React.createElement(SecondaryNav, __assign({}, secondaryNavigation)))))));
};
